import logoFrotaWeb from '../assets/logo-frotaweb.png'

interface Props {
  height?: number
  className?: string
}

/* Marca oficial do FrotaWeb (PNG com fundo transparente, 866x288).
   Mesma construção da do FrotaTrack — a "asa", o wordmark em azul + laranja e a
   assinatura embaixo — porque são produtos irmãos.

   Substituiu um wordmark que era desenhado em SVG aqui dentro. O `variant`
   (claro/escuro) sumiu junto: o PNG é um só e vale nos dois fundos, como o
   logo-frotatrack.png vale na barra lateral navy e no login de lá.

   Altura, não largura: a proporção é ~3:1 e o navegador calcula a largura. */
export default function LogoFrotaWeb({ height = 34, className }: Props) {
  return (
    <img
      src={logoFrotaWeb}
      alt="FrotaWeb — Gestão Empresarial"
      height={height}
      style={{ height, width: 'auto' }}
      className={className}
    />
  )
}
